<template>
    <div name="home" class="home" v-if="step === 0">
        <img style="width: 100%;" src="../../assets/showcase/xi/home/1.png" />
        <!-- <img style="width: 100%;" src="../../assets/showcase/xi/home/lottery.png" /> -->
        <img style="width: 100%;" src="../../assets/showcase/xi/home/inbody.png" @click="goInbody"/>
        <img style="width: 100%;" src="../../assets/showcase/xi/home/department1.png" @click="departmentClick"  />
        <div class="wrapper">
            <img style="width: 100%;position: relative;" src="../../assets/showcase/xi/home/department2.png" @click="departmentClick" />
            <div class="plus-button" @click="plusClick"></div>
        </div>
        <img style="width: 100%; margin-top: -10px;" src="../../assets/showcase/xi/home/4.png" />
        <img style="width: 100%;" src="../../assets/showcase/xi/home/5.png" />
        <!-- <img style="width: 100%;" src="../../assets/showcase/xi/home/6.png" /> -->
        <img style="width: 100%;" src="../../assets/showcase/xi/home/7.png" />
        <img style="width: 100%;" class="bottom" src="../../assets/showcase/xi/home/8.png" />
        <!-- <img style="width: 100%;" src="../../assets/showcase/xi/home/9.png" /> -->
    </div>
    <div v-else class="home">
        <img class="image" src="../../assets/showcase/xi/home/add/1.png" @click="step = 0"/>
        <div class="bottom fix" v-if="tab === 0">
            <img class="image" src="../../assets/showcase/xi/home/add/2.png" @click="tab = 1"/>
            <img class="image" src="../../assets/showcase/xi/home/add/3.png" style="margin-top: -6px;" @click="departmentClick" />
        </div>
        <div class="bottom fix" v-else>
            <img class="image" src="../../assets/showcase/xi/home/add/4.png" @click="tab= 0"/>
            <img class="image" src="../../assets/showcase/xi/home/add/5.png" style="margin-top: -6px;" @click="departmentClick"/>
        </div>
    </div>
</template>

<script>
export default {
    data: function()
    {
        return {
            step: 0,
            tab: 0
        }
    },
    methods: {
        departmentClick: function() {
            this.$emit('goBooking');
            // this.$router.push({name: 'menu'});
        },
        plusClick: function() {
            this.step = 1;
            // alert("플러스 버튼 클릭")
            // this.$router.push({name: 'preview'});
        },
        goInbody: function()
        {
            this.$emit('goInbody')
        }   
    }
}
</script>

<style scoped>
    .plus-button {
        aspect-ratio: 1;
        height: 90%;
        top: 0;
        right: 2vw;
        position: absolute;
        z-index: 1;
    }   
    .wrapper {
        position: relative;
        width: 100%;
    }
    .bottom {
        margin-bottom: calc(100vw * 120 / 375);
        background: #FFF;
    }
    .fix {
        position: fixed;
        bottom: 0;
        position: fixed; 
        width: calc(80%);
        left: 50%;
        transform: translate(-50%, 0);
    }
    .home {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        background: #FFF;
        width: 100%;
        position: relative;

    }
    .image {
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Home.vue